/**
 * https://stackoverflow.com/questions/27936772/how-to-deep-merge-instead-of-shallow-merge
 * Simple object check.
 */
function isObject(item: any): boolean {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 */
export function mergeDeep(...sources: Object[]) {
    return mergeDeepMutable({}, ...sources);
}
export function mergeDeepMutable(target: Object, ...sources: Object[]) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            // @ts-ignore
            if (isObject(source[key] as any)) {
                // @ts-ignore
                if (!target[key]) Object.assign(target, {[key]: {}});
                // @ts-ignore
                mergeDeepMutable(target[key], source[key]);
            } else {
                // @ts-ignore
                Object.assign(target, {[key]: source[key]});
            }
        }
    }

    return mergeDeepMutable(target, ...sources);
}

export function clone(o: Object) {
    return mergeDeepMutable({}, o);
}
